<template lang="pug">
  .w-full.min-w-1024.bg-grey-f2.min-h-full.min-h-screen.relative()
    Loading.min-w-1024.z-600(v-if="$store.state.common.requestLoading > 0")
    Header.absolute.top-0.w-full(@closeUser="showInfo(true)" @releaseNote="showRelease(true)")
    
    .main
      .flex.justify-center.pt-76.min-w-1024.w-full.min-h-screen.pb-200(ref="mainBox" :class="{'pt-110': $route.name != 'FAQ'}")
        .block.w-full
          router-view
      .quadrilateral
    Footer.min-w-1024.bottom-0.relative
    UserInfo( :show="infoIsShow" @closeUser="showInfo()")
    RightInfo( :show="rightInfoIsShow" @closeRight="showRelease")
</template>

<script>
import Loading from '@/components/Loading.vue';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import UserInfo from '@/components/User.vue';
import RightInfo from '@/components/RightInfo.vue';



export default {
  name: 'Home',
  components: {
    Loading,
    Header,
    Footer,
    UserInfo,
    RightInfo
  },
  data(){
    return {
      infoIsShow:false,
      rightInfoIsShow:false,
    }
  },
  created(){
  },
  mounted(){

  },
  methods:{

    showInfo(e) {
      this.infoIsShow = e;
    },
    showRelease(e){
      this.rightInfoIsShow = e;
    }
  },
  watch:{
  }

}


</script>



<style lang="scss" scoped>


Footer{
  margin-top: -160px;
  clear: both;
}

.main{
  .quadrilateral{
    height: 340px;
    bottom: 80px;
    right: 0;
    border-top: 140px solid transparent;
    border-right: 100vw solid #e6e6e6;
    position: absolute;
  }
}

@media screen and (max-width: 1024px) { 
  .quadrilateral{
    border-right: 1024px solid #e6e6e6 !important;
  }
}
</style>

